export const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };
  